/* eslint-disable */

import moment from 'moment';
import React, { useState, useRef, useEffect } from 'react';
import DateRangePicker from './RedesignedDatePicker';
import { gsc_report_query, query } from '../../FilterOptions/query';
import getDataRange from '../../../helpers/getDataRange';

const DateRangePickerContainer = (props) => {
    const [open, setOpen] = useState(false);
    const [minMaxDates, setMinMaxDates] = useState({});
    const dropdownRef = useRef(null);

    const handleToggle = () => setOpen((prev) => !prev);

    const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        async function getData() {
            const request = props.gsc_report ? gsc_report_query : query;
            const data = await request.update();
            setMinMaxDates(data?.[0] ?? {});
        }
        getData();
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const default_filter = urlParams.get('default_filter');
        if (default_filter === 'today' && window?.filters?.filters?.dates?.id !== 'current_day') {
            const todayOption = props.options.find((item) => item.id === 'current_day');
            if (!todayOption) return;
            const choiceValue = getDataRange(todayOption);
            const selectedChoice = { ...todayOption, values: choiceValue };
            props.updateSelect(selectedChoice);
        }
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const { start_date, end_date } = getDataRange(
        window?.filters?.filters?.dates,
        props.is_from_tools,
    );
    return (
        <div className="dropdown-container" ref={dropdownRef}>
            <button onClick={handleToggle} className="date-picker-global-input">
                <span className="d-flex gap-8 align-items-center">
                    <i className="icon-calendar1" />
                    {moment(start_date?.value).format('DD MMM YYYY')} -{' '}
                    {moment(end_date?.value).format('DD MMM YYYY')}
                </span>
                <i className="icon-fi_chevron-down" />
            </button>

            {open && (
                <div className="dropdown-panel">
                    <div className="calendar-wrapper">
                        <DateRangePicker
                            updateSelect={props.updateSelect}
                            options={props.options}
                            dateFilterValue={props.dateFilterValue}
                            gsc_report={props.gsc_report}
                            onClose={() => setOpen(false)}
                            minDate={minMaxDates?.mindate?.value}
                            maxDate={minMaxDates?.maxdate?.value}
                            is_from_tools={props.is_from_tools}
                            hasOptions
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DateRangePickerContainer;
